module.exports = __webpack_public_path__ + "static/img/my-medal-top-div-bg.9e1dade.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person/my-medal-top-div-bg.png
// module id = 3rgE
// module chunks = 1